// alterado - revisado

const videoCasoNegocioList = [
    {
        id: '010.010',
        descricao: 'Primeiro Acesso',
        idFuncionalidade: '010',
        ordem: '010.010',
    },
    {
        id: '100.010',
        descricao: 'Introdução',
        idFuncionalidade: '100',
        ordem: '100.010',
    },
    {
        id: '180.010',
        descricao: 'Como deixar cenários de rentabilidade e expectativa de vida padronizados',
        idFuncionalidade: '180',
        ordem: '180.010',
    },
    {
        id: '200.010',
        descricao: 'Personalizando o relatório que é entregue ao cliente',
        idFuncionalidade: '200',
        ordem: '200.010',
    },
    {
        id: '500.010',
        descricao: 'Introdução',
        idFuncionalidade: '500',
        ordem: '500.010',
    },
    {
        id: '500.020',
        descricao: 'Entendendo as diferentes trilhas da Fin-Tracks',
        idFuncionalidade: '500',
        ordem: '500.020',
    },
    {
        id: '500.030',
        descricao: 'Apólices de Seguros de Vida',
        idFuncionalidade: '500',
        ordem: '500.030',
    },
    {
        id: '500.040',
        descricao: 'Como a Fin-Track$ pode ajudar a dimensionar e captar mais recursos para a previdência privada?',
        idFuncionalidade: '500',
        ordem: '500.040',
    },
    {
        id: '505.010',
        descricao: 'Envolva seu cliente permitindo o input de dados ou a visualização dos relatórios pelo sistema',
        idFuncionalidade: '505',
        ordem: '505.010',
    },
    {
        id: '510.010',
        descricao: 'Envolva seu cliente permitindo o input de dados ou a visualização dos relatórios pelo sistema',
        idFuncionalidade: '510',
        ordem: '510.010',
    },
    {
        id: '520.010',
        descricao: 'Desejando 40 mil de Padrão de Vida',
        idFuncionalidade: '520',
        ordem: '520.010',
    },
    {
        id: '520.020',
        descricao: 'Como deixar cenários de rentabilidade e expectativa de vida padronizados',
        idFuncionalidade: '520',
        ordem: '520.020',
    },
    {
        id: '520.030',
        descricao: 'Lançamento de aportes',
        idFuncionalidade: '520',
        ordem: '520.030',
    },
    {
        id: '574.010',
        descricao: 'Introdução',
        idFuncionalidade: '574',
        ordem: '574.010',
    },
    {
        id: '574.020',
        descricao: 'Lançamento de aportes',
        idFuncionalidade: '574',
        ordem: '574.020',
    },
    {
        id: '576.010',
        descricao: 'Vale a pena o seu cliente fazer aportes no PGBL?',
        idFuncionalidade: '576',
        ordem: '576.010',
    },
    {
        id: '578.010',
        descricao: 'Personalize o relatório do seu cliente',
        idFuncionalidade: '578',
        ordem: '578.010',
    },
    {
        id: '578.020',
        descricao: 'Como tornar a apresentação do relatório mais rápida e visual',
        idFuncionalidade: '578',
        ordem: '578.020',
    },
]

export default videoCasoNegocioList